import Link from 'next/link';
import React from 'react';

const LetsMeetInUsa = () => {
    const scrollToSection = (sectionId: string) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <div className="section-py bg-usa-cta">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-2.5 fs-xxl text-white">
                            Let&apos;s Meet in the USA
                        </h2>
                        <p className="mb-2.5 fs-xl text-white">
                            This is more than just a meeting—it&apos;s an opportunity to transform your business. Let&apos;s
                            connect, collaborate, and explore the future of your business, together.
                        </p>
                        <Link href={'#'} className="btn btn-primary cursor-pointer" onClick={() => scrollToSection('section1')}>
                            Book Your Exclusive Session Now!
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LetsMeetInUsa;
